import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgElGrecoCustomChevronRight({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={42}
      viewBox="0 0 12 42"
      fill="none"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M1.5 1.002c-.128 0-.256.103-.354.307-.195.411-.195 1.078 0 1.489l8.647 18.203-8.647 18.203c-.195.41-.195 1.078 0 1.488.195.41.512.41.707 0l9-18.948c.196-.41.196-1.078 0-1.488l-9-18.949C1.755 1.101 1.627 1 1.5 1l.001.002z"
        fill="#000"
        stroke="#000"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgElGrecoCustomChevronRight;
